var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKbvV16TipsAiPredictIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30.936,
    height: 29.68,
    viewBox: "0 0 30.936 29.68",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "viugo_rg",
    cx: 1.078,
    cy: 0.319,
    r: 1.003,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#72787b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222,
    stopColor: "#4a4f53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#262b2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#101418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#080c10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#080c10"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "viugo_cp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.164,183.926h.026l1.183,3.444h-2.432Zm-.95-2.313a.108.108,0,0,0-.1.07l-3.467,9.168a.108.108,0,0,0,.1.146h1.843a.108.108,0,0,0,.1-.072l.711-2.018h3.509l.685,2.016a.108.108,0,0,0,.1.073h1.909a.108.108,0,0,0,.1-.146l-3.428-9.168a.108.108,0,0,0-.1-.07Z",
    transform: "translate(-152.638 -181.613)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "viugo_rg2",
    cx: 0.878,
    cy: 0.326,
    r: 0.852,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eccd67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#e6bd5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e3c773"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "viugo_cp2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.064,
    height: 9.385,
    rx: 0.2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "viugo_rg3",
    cx: -0.947,
    cy: 0.326,
    r: 0.852,
    xlinkHref: "#viugo_rg2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-824.149 -415.6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(829.526 419.72)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.231,
    height: 18.231,
    rx: 9.115,
    transform: "translate(0 14.47) rotate(-52.535)",
    fill: "url(#viugo_rg)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.362 7.629)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#viugo_cp)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.117,
    height: 9.385,
    transform: "translate(-0.02 0)",
    fill: "url(#viugo_rg2)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.941 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#viugo_cp2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.064,
    height: 9.385,
    transform: "translate(0)",
    fill: "url(#viugo_rg3)"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.914, -0.407, 0.407, 0.914, 822.844, 419.962)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.428 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5.947c.026-.061.14,0,.14,0a6.311,6.311,0,0,0,1.393,3.2A6.022,6.022,0,0,0,10.188,5.5c.061.026,0,.14,0,.14a6.311,6.311,0,0,0-3.2,1.393,6.022,6.022,0,0,0-1.353,3.158c-.026.061-.14,0-.14,0A6.311,6.311,0,0,0,4.1,6.991,6.022,6.022,0,0,0,.947,5.637c-.061-.026,0-.14,0-.14A6.311,6.311,0,0,0,4.145,4.1,6.022,6.022,0,0,0,5.5.947Z",
    transform: "translate(-0.92 -0.92)",
    fill: "#ffeb39"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 9.064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.215.933c.013-.031.07,0,.07,0a3.164,3.164,0,0,0,.7,1.6,3.019,3.019,0,0,0,1.583.679c.031.013,0,.07,0,.07a3.164,3.164,0,0,0-1.6.7,3.019,3.019,0,0,0-.679,1.583c-.013.031-.07,0-.07,0a3.164,3.164,0,0,0-.7-1.6A3.019,3.019,0,0,0,.933,3.285c-.031-.013,0-.07,0-.07a3.164,3.164,0,0,0,1.6-.7A3.019,3.019,0,0,0,3.215.933Z",
    transform: "translate(-0.92 -0.92)",
    fill: "#ffeb39"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.912 5.152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.535.929c.009-.022.049,0,.049,0a2.227,2.227,0,0,0,.492,1.128,2.125,2.125,0,0,0,1.114.478c.022.009,0,.049,0,.049a2.227,2.227,0,0,0-1.128.492A2.125,2.125,0,0,0,2.585,4.19c-.009.022-.049,0-.049,0a2.227,2.227,0,0,0-.492-1.128A2.125,2.125,0,0,0,.929,2.585c-.022-.009,0-.049,0-.049a2.227,2.227,0,0,0,1.128-.492A2.125,2.125,0,0,0,2.535.929Z",
    transform: "translate(-0.92 -0.92)",
    fill: "#ffeb39"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKbvV16TipsAiPredictIcon);
export default __webpack_public_path__ + "static/media/kbv-v16-tips-ai-predict-icon.e2ec3959e3c2e3c9ea53d534bdd80bf7.svg";
export { ForwardRef as ReactComponent };